// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.email-form {
  width: 100%;
  height: 100%;
  background-color: #fafafa;
}

.input-mat {
  border-radius: 30px;
  width: 100%;
  height: 30px;
  border: 1px solid #ccc;
  background: white;
  padding-left: 10px;
}

.textarea-mat {
  background-color: white;
  width: 100%;
  border-radius: 15px;
  padding-top: 10px;
  padding-left: 15px;
  margin-top: 15px;
  border: 1px solid #ccc;
  resize: none;
  height: 120px;
}

.form-wrapper {
  padding-left: 25px;
  padding-right: 25px;
}

.priority {
  float: right;
  padding-top: 20px;
}

.to-field {
  display: block;
  width: 100%;
  height: 70px;
  overflow-y: auto;
  overflow-x: hidden;
  background-color: white;
  border-radius: 5px;
  border: 1px solid #ccc;
  padding-left: 2px;
}
.to-field .emailRecipient {
  padding: 4px 7px;
  border-radius: 12px;
  margin: 2px 3px;
  background-color: #12A7E6;
  color: white;
  font-size: 1rem;
  line-height: 1rem;
  white-space: break-spaces;
  display: inline-block;
}

.subjectRow {
  margin-top: 5px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.subjectRow .subjectRow--subject {
  flex-basis: 80%;
}

.fileAttachmentSection .fileAttachmentSection--button {
  margin-top: 10px;
}

button {
  margin-left: 15px;
  border-radius: 22px;
  width: 100px;
}

.full-width {
  width: 100%;
}

.row {
  font-family: "Lato", sans-serif;
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 50px;
}

.column {
  font-family: "Lato", sans-serif;
  display: flex;
  flex-direction: column;
  flex: 1 100%;
}

.close-icon {
  color: #204060;
  cursor: pointer;
  float: right;
  font-size: 20px;
  padding-top: 20px;
}

th {
  font-weight: 800;
  font-size: small;
  text-align: left;
  /*font-weight: 300 !important;
    color: #a3a3a3;
    padding-top: 15px;
    padding-bottom: 15px;*/
}

table {
  width: 100%;
  background-color: #f0f0f0;
}

td {
  font-weight: 400;
  font-size: small;
  text-align: left;
  font-size: 12px;
}

/* Scrollbar styles */
::-webkit-scrollbar-button {
  background: white;
}

.half-width {
  width: 50%;
  margin: 0.5rem;
}

.alert-info-container {
  display: flex;
  justify-content: space-evenly;
}

.fixed-height {
  height: 85px;
}

.additional-recipients {
  margin-top: 1rem;
}
.additional-recipients .additional-recipients-label {
  font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/email/email.component.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,YAAA;EACA,yBAAA;AACF;;AAEA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,iBAAA;EACA,kBAAA;AACF;;AAEA;EACE,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;AACF;;AAIA;EACE,YAAA;EACA,iBAAA;AADF;;AAIA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,sBAAA;EACA,iBAAA;AADF;AAEE;EACE,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,qBAAA;AAAJ;;AAIA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AADF;AAEE;EACE,eAAA;AAAJ;;AAKE;EACE,gBAAA;AAFJ;;AAOA;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;AAJF;;AAOA;EACE,WAAA;AAJF;;AAOA;EACE,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAJF;;AAOA;EACE,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAJF;;AAOA;EACE,cAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA;;;0BAAA;AADF;;AAOA;EACE,WAAA;EACA,yBAAA;AAJF;;AAOA;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAJF;;AAQA,qBAAA;AAWA;EACE,iBAAA;AAfF;;AAkBA;EACE,UAAA;EACA,cAAA;AAfF;;AAkBA;EACE,aAAA;EACA,6BAAA;AAfF;;AAkBA;EACE,YAAA;AAfF;;AAkBA;EACE,gBAAA;AAfF;AAiBE;EACE,iBAAA;AAfJ","sourcesContent":[".email-form {\n  width: 100%;\n  height: 100%;\n  background-color: #fafafa;\n}\n\n.input-mat {\n  border-radius: 30px;\n  width: 100%;\n  height: 30px;\n  border: 1px solid #ccc;\n  background: white;\n  padding-left: 10px;\n}\n\n.textarea-mat {\n  background-color: white;\n  width: 100%;\n  border-radius: 15px;\n  padding-top: 10px;\n  padding-left: 15px;\n  margin-top: 15px;\n  border: 1px solid #ccc;\n  resize: none;\n  height: 120px;\n}\n\n.form-wrapper {\n  padding-left: 25px;\n  padding-right: 25px;\n}\n\n\n\n.priority {\n  float: right;\n  padding-top: 20px;\n}\n\n.to-field {\n  display: block;\n  width: 100%;\n  height: 70px;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background-color: white;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  padding-left: 2px;\n  .emailRecipient {\n    padding: 4px 7px;\n    border-radius: 12px;\n    margin: 2px 3px;\n    background-color: #12A7E6;\n    color: white;\n    font-size: 1.0rem;\n    line-height: 1rem;\n    white-space: break-spaces;\n    display: inline-block;\n  }\n}\n\n.subjectRow{\n  margin-top: 5px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  .subjectRow--subject {\n    flex-basis: 80%;\n  }\n}\n\n.fileAttachmentSection {\n  .fileAttachmentSection--button {\n    margin-top: 10px;\n  }\n}\n\n//Styling buttons with round corners\nbutton {\n  margin-left: 15px;\n  border-radius: 22px;\n  width: 100px;\n}\n\n.full-width {\n  width: 100%;\n}\n\n.row {\n  font-family: 'Lato', sans-serif;\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  height: 50px;\n}\n\n.column {\n  font-family: 'Lato', sans-serif;\n  display: flex;\n  flex-direction: column;\n  flex: 1 100%;\n}\n\n.close-icon {\n  color: #204060;\n  cursor: pointer;\n  float: right;\n  font-size: 20px;\n  padding-top: 20px;\n}\n\nth {\n  font-weight: 800;\n  font-size: small;\n  text-align: left;\n  /*font-weight: 300 !important;\n    color: #a3a3a3;\n    padding-top: 15px;\n    padding-bottom: 15px;*/\n}\n\ntable {\n  width: 100%;\n  background-color: #f0f0f0;\n}\n\ntd {\n  font-weight: 400;\n  font-size: small;\n  text-align: left;\n  font-size: 12px;\n}\n\n\n/* Scrollbar styles */\n::-webkit-scrollbar {\n\n}\n\n::-webkit-scrollbar-track {\n}\n\n::-webkit-scrollbar-thumb {\n}\n\n::-webkit-scrollbar-button {\n  background:white;\n}\n\n.half-width {\n  width: 50%;\n  margin: 0.5rem;\n}\n\n.alert-info-container {\n  display: flex;\n  justify-content: space-evenly;\n}\n\n.fixed-height {\n  height: 85px;\n}\n\n.additional-recipients {\n  margin-top: 1rem;\n\n  .additional-recipients-label {\n    font-weight: bold;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
